module.exports = __webpack_public_path__ + "img/potion-small.477db5d1.svg";